import React from "react";
import { ShieldCheck } from "lucide-react";
import { GuidelinesContent } from "@/components/GuidelinesContent";

export default function Guidelines() {
  return (
    <div data-testid="guidelines-page" className="bg-card border border-border rounded-2xl p-6 sm:p-8">
      <div className="flex items-center gap-3 mb-2">
        <ShieldCheck className="w-7 h-7 text-[#C084FC]" />
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold">Community Guidelines</h1>
      </div>
      <p className="text-sm text-muted-foreground mb-6">The simple rules that keep Xealth healthy and trustworthy for everyone.</p>
      <GuidelinesContent />
    </div>
  );
}
